import Endpoints from '@nikan/endpoints'

export default () => {
  Endpoints.addModule('/api/', [
    { name: 'token', address: 'token' }
  ])
  Endpoints.addModule('/api/v1.0/system/', [
    { name: 'general.version', address: 'global/version' },
    { name: 'general.statusBar', address: 'global/StatusBarInfo' },
    { name: 'general.dataCount', address: 'global/GetDataInformation' },

    { name: 'general.appStates.list', address: 'AppState/List' },
    { name: 'general.appStates.modify', address: 'AppState/Modify' },
    { name: 'general.clearServerCache', address: 'AppState/Clear' },

    { name: 'general.get-today', address: 'general/GetToday' },
    { name: 'general.generateKey', address: 'general/GenerateKey' },
    { name: 'download.download', address: file => 'Download/Download?fileName=' + file },
    { name: 'download.convertHtmlToPDF', address: file => 'Download/ConvertHtmlToPDF' },

    // general-search
    { name: 'general-search.list', address: 'generalsearch/get' },

    // profile reports
    { name: 'profile-reports.list', address: 'ProfileReport/List' },
    { name: 'profile-reports.create', address: 'ProfileReport/Create' },
    { name: 'profile-reports.delete', address: 'ProfileReport/Delete' },
    { name: 'profile-reports.edit', address: 'ProfileReport/Edit' },
    { name: 'profile-reports.getByKey', address: 'ProfileReport/GetByKey' },

    // form
    { name: 'general.forms', address: 'FormAutoAccountType/ListFormsWithAutoAccountTypes' },
    { name: 'general.system-forms', address: 'Form/ListDynamic' },

    // excel operation
    { name: 'excel.getHeaders', address: 'ExcelOperation/GetHeaders' },

    { name: 'system.excel.getFields', address: 'ExcelOperation/GetFields' },
    { name: 'system.excel.import', address: 'ExcelOperation/Import' },
    { name: 'system.download.export', address: 'Download/Export' },

    // demo
    { name: 'demo.bidata', address: 'home/bigdata' },
    { name: 'demo.bidata2', address: 'home/bigdata2' },

    // User
    { name: 'user.RefreshToken', address: 'user/RefreshToken' },
    { name: 'user.list-dynamic', address: 'user/ListDynamic' },
    { name: 'user.list', address: 'user/List' },
    { name: 'user.getProfile', address: 'user/getProfile' },
    { name: 'user.get-id', address: id => 'user/get?id=' + id },
    { name: 'user.get', address: id => 'user/get' },
    { name: 'user.create', address: 'user/create' },
    { name: 'user.update', address: 'user/update' },
    { name: 'user.delete', address: 'user/delete' },
    { name: 'user.roleList', address: 'user/ListRoles' },
    { name: 'user.logout-log', address: 'user/UserLogoutLog' },
    { name: 'user.online-list', address: 'User/OnlineUsers' },

    // accounts
    { name: 'accounts.list', address: 'account/list' },
    { name: 'accounts.delete', address: id => 'account/delete/' + id },
    { name: 'accounts.getByCode', address: 'account/getEditModel' },

    { name: 'accounts.create', address: 'account/create' },
    { name: 'accounts.update', address: 'account/update' },
    { name: 'accounts.groups', address: 'account/groups' },
    { name: 'accounts.types', address: 'account/types' },
    { name: 'accounts.natures', address: 'account/natures' },
    { name: 'accounts.linktoCenters', address: 'account/modifyLinkedFloatingCenters' },
    { name: 'accounts.linktoCentersTopLevel', address: 'account/LinkTopLevelAccountToFloatingCenters' },
    { name: 'accounts.centersLinkedToAccount', address: 'account/getLinkedFloatingCenters' },
    { name: 'accounts.copyFromOtherFiscalPeriod', address: 'account/CopyFromOtherFiscalPeriod' },
    { name: 'accounts.copyFromOtherCompany', address: 'account/copyFromOtherCompany' },
    { name: 'accounts.copyDefaultSystemAccounts', address: 'account/copyDefaultSystemAccounts' },
    { name: 'accounts.copyDefaultSystemAccounts', address: 'account/copyDefaultSystemAccounts' },
    { name: 'accounts.validateInStart', address: 'account/ValidateInStart' },
    { name: 'accounts.checkCompanyHasAccount', address: 'account/CheckCompanyHasAccount' },

    // auto accounts
    { name: 'accounts.auto.list', address: 'AutoAccount/List' },
    { name: 'accounts.auto.listOfMine', address: 'AutoAccount/ListByUserId' },
    { name: 'accounts.auto.types', address: 'AutoAccountType/ListDynamic' },
    { name: 'accounts.auto.modify', address: 'AutoAccount/Modify' },

    // Companies
    { name: 'companies.list', address: 'company/list' },
    { name: 'companies.get', address: id => 'company/get' },
    { name: 'companies.create', address: 'company/create' },
    { name: 'companies.update', address: 'company/update' },
    { name: 'companies.delete', address: id => 'company/delete/' + id },
    { name: 'companies.types', address: 'company/types' },
    { name: 'companies.nationalities', address: 'company/nationalities' },
    { name: 'companies.getCurrencies', address: 'company/listCurrencies' },

    // Floating Centers
    { name: 'floatingCenters.list', address: 'FloatingCenter/List' },
    { name: 'floatingCenters.get', address: 'FloatingCenter/Get' },
    { name: 'floatingCenters.get-edit-model', address: 'FloatingCenter/GetEditModel' },
    { name: 'floatingCenters.create', address: 'FloatingCenter/Create' },
    { name: 'floatingCenters.update', address: 'FloatingCenter/Update' },
    { name: 'floatingCenters.delete', address: 'FloatingCenter/Delete' },
    { name: 'floatingCenters.validateInStart', address: 'FloatingCenter/ValidateInStart' },
    { name: 'floatingCenters.link-accounts', address: 'FloatingCenter/ModifyFloatingCenterAccounts' },
    { name: 'floatingCenters.pageList', address: 'FloatingCenter/PagedList' },
    { name: 'floatingCenters.pagedSearch', address: 'FloatingCenter/PagedSearch' },
    { name: 'floatingCenters.get-floating-center-balance-until-date', address: 'FloatingCenter/GetFloatingCentersBalanceUntiDate' },


    // dashboard
    { name: 'documentDetails.list', address: 'Dashboard/GetDocumentStatistics' },
    { name: 'camercialAccess.get', address: 'Dashboard/GetCommercialAccess' },

    // floatingCenterCategories
    { name: 'floatingCenterCategory.search', address: 'FloatingCenterCategory/ListDynamic' },
    { name: 'floatingCenterCategory.modify', address: 'FloatingCenterCategory/Modify' },

    // bank
    { name: 'bank.list', address: 'Bank/ListDynamic' },
    { name: 'bank.modify', address: 'Bank/Modify' },

    // documentTypes
    { name: 'documentTypes.list', address: 'DocumentType/ListDynamic' },

    // install
    { name: 'install.install', address: 'install/install' },
    { name: 'install.getStatus', address: 'install/getStatus' },
    { name: 'install.checkCommercialAccess', address: 'install/CheckCommercialAccess' },

    // launch
    { name: 'launcher.status', address: 'launcher/status' },
    { name: 'launcher.migration', address: 'launcher/migration' },


    // Login
    { name: 'user.sendRecoveryEmail', address: 'user/SendRecoveryPasswordEmail' },
    { name: 'user.ValidateResetToken', address: 'user/ValidateResetPasswordToken' },
    { name: 'user.ResetPasswordByEmail', address: 'user/ResetPasswordByEmail' },


    // General
    { name: 'general.readresourcefile', address: id => 'global/readresourcefile/' + id },
    { name: 'general.dataChanges', address: date => 'global/data-changes/' + date },
    { name: 'general.getAllProperties', address: 'property/listDynamic' },
    { name: 'general.get-today', address: 'general/GetToday' },

    // MetaData
    { name: 'metadata.modify', address: id => 'MetaData/Modify' },
    { name: 'metadata.listDynamic', address: 'MetaData/ListDynamic' },
    { name: 'metadata.list', address: 'MetaData/List' },

    // demo
    { name: 'demo.bidata', address: 'home/bigdata' },
    { name: 'demo.bidata2', address: 'home/bigdata2' },

    // floatingCenters
    // { name: 'floatingCenters.listWithAccounts', address: 'floatingcenter/list-with-accounts' },
    { name: 'floatingCenters.getById', address: id => 'FloatingCenter/get/' + id },
    { name: 'floatingCenters.search', address: 'FloatingCenter/search' },
    { name: 'floatingCenters.groups', address: 'floatingcenter/groups' },

    // documents
    { name: 'documents.list', address: 'document/List' },
    { name: 'documents.listDynamic', address: 'document/ListDynamic' },
    { name: 'documents.list-for-selector', address: 'document/ListForSelector' },
    { name: 'documents.details', address: 'document/doc-details' },
    { name: 'documents.get', address: 'document/get' },
    { name: 'documents.fullData', address: 'document/fullData' },
    { name: 'documents.navigate', address: 'document/navigate' },
    { name: 'documents.create', address: 'document/create' },
    { name: 'documents.createOpening', address: 'document/createOpening' },
    { name: 'documents.update', address: 'document/Update' },
    { name: 'documents.delete', address: 'document/Delete' },
    { name: 'documents.get-last-document-code', address: 'document/GetLastDocumentCode' },
    { name: 'documents.get-opening', address: 'document/GetOpening' },
    { name: 'documents.operation', address: 'Document/ChangeTypeOfDocuments' },
    { name: 'documents.sorting', address: 'Document/DocumentSorting' },
    { name: 'documents.get-document-ref', address: 'Document/GetDocumentRef' },
    { name: 'documents.merge', address: 'Document/Merge' },
    { name: 'documents.list-by-account-for-change-account', address: 'Document/ListByAccountForChangeAccount' },
    { name: 'documents.change-document-account', address: 'Document/ChangeDocumentAccount' },
    { name: 'documents.list-by-center-for-change-center', address: 'Document/ListByCenterForChangeCenter' },
    { name: 'documents.change-document-center', address: 'Document/ChangeDocumentCenter' },
    { name: 'documents.bulk-delete', address: 'Document/BulkDelete' },
    { name: 'documents.modify-detail-index', address: 'document/ModifyDetailIndex' },
    { name: 'documents.modify-productStockAccount-of-opening', address: 'document/ModifyProductStockAccountOfOpening' },


    // documentTypes
    { name: 'documentTypes.list', address: 'documentType/listDynamic' },
    { name: 'documentTypes.modify', address: 'documentType/modify' },

    // fiscal
    { name: 'fiscalPeriod.listAll', address: 'fiscalPeriod/listAll/' },
    { name: 'fiscalPeriod.list', address: 'fiscalPeriod/list/' },
    { name: 'fiscalPeriod.get', address: id => 'fiscalPeriod/get' },
    { name: 'fiscalPeriod.create', address: 'fiscalPeriod/create' },
    { name: 'fiscalPeriod.update', address: 'fiscalPeriod/update' },
    { name: 'fiscalPeriod.delete', address: id => 'fiscalPeriod/delete/' + id },
    { name: 'companies.fiscalPeriod.setDefault', address: id => 'company/fiscal/set-default/' + id },

    // units
    { name: 'units.search', address: 'unit/search' },

    // currency
    { name: 'systemCurrency.list', address: 'systemCurrency/listDynamic' },

    // currencyRate
    { name: 'currencyRate.list', address: 'currencyRate/list' },
    { name: 'currencyRate.modify', address: 'currencyRate/modify' },

    // city
    { name: 'city.list', address: 'city/listDynamic' },
    { name: 'city.modify', address: 'city/Modify' },

    // taxOffice
    { name: 'taxOffice.list', address: 'taxOffice/listDynamic' },
    { name: 'taxOffice.modify', address: 'taxOffice/Modify' },

    // taxZone
    { name: 'taxZone.list', address: 'taxZone/listDynamic' },
    { name: 'taxZone.modify', address: 'taxZone/Modify' },

    // settings
    { name: 'settings.get', address: 'setting/GetAccountingSettings' },
    { name: 'settings.modify', address: 'setting/ModifyAccountingSettings' },
    { name: 'settings.reset', address: 'setting/ResetAccountingSettings' },
    { name: 'api-settings.get', address: 'Setting/GetApiSettings' },
    { name: 'api-settings.modify', address: 'Setting/ModifyApiSettings' },

    // report
    { name: 'customAccountCrawling.create', address: 'report/CreateCustomCrawlingReport' },
    { name: 'customAccountCrawling.update', address: 'report/UpdateCustomCrawlingReport' },
    { name: 'customAccountCrawling.delete', address: 'report/DeleteCustomCrawlingReport' },
    { name: 'customAccountCrawling.list', address: 'report/GetCustomCrawlingReportList' },
    { name: 'customAccountCrawling.get', address: 'report/GetCustomCrawlingReport' },
    { name: 'customAccountCrawling.execute', address: 'report/ExecuteCustomCrawlingReport' },
    { name: 'reports.account-crawling', address: 'report/account-crawling' },
    { name: 'reports.account-cardx', address: 'report/account-cardx' },
    { name: 'reports.get', address: 'report/get' },
    { name: 'reportsCategory.list', address: 'reportCategory/list' },
    { name: 'reportsCategory.get', address: 'reportCategory/get' },
    { name: 'reportsCategory.create', address: 'reportCategory/create' },
    { name: 'reportsCategory.update', address: 'reportCategory/update' },
    { name: 'reportsCategory.delete', address: 'reportCategory/delete' },
    { name: 'reportsDynamic.create', address: 'report/createDynamicReport' },
    { name: 'reportsDynamic.update', address: 'report/updateDynamicReport' },
    { name: 'reportsDynamic.delete', address: 'report/deleteDynamicReport' },
    { name: 'reportsDynamic.get', address: 'report/getDynamicReport' },
    { name: 'reportsDynamic.list', address: 'report/getDynamicReportList' },
    { name: 'reportsDynamic.execute', address: 'report/executeDynamicReport' },
    { name: 'ledger.calculate', address: 'ledger/Calculate' },
    { name: 'ledger.delete', address: 'ledger/Delete' },
    { name: 'ledger.get', address: 'ledger/Get' },
    { name: 'ledger.list', address: 'ledger/List' },
    { name: 'ledger.documents', address: 'ledger/Documents' },



    // EntityStructure
    { name: 'entityStructure.get', address: 'EntityStructure/Get' },
    { name: 'entityStructure.getEnumItems', address: 'EntityStructure/GetEnumItems' },


    { name: 'measureunit.get-list-dynamic', address: 'MeasureUnit/ListDynamic' },
    { name: 'measureunit.get-single-dynamic', address: 'MeasureUnit/GetDynamic' },
    { name: 'measureunit.modify', address: 'MeasureUnit/Modify' },
    { name: 'measureunit.moadianUnitList', address: 'MeasureUnit/MoadianUnitList' },

    // OperationRole
    { name: 'operationRole.list', address: 'operationRole/List' },
    { name: 'operationRole.create', address: 'operationRole/Create' },
    { name: 'operationRole.update', address: 'operationRole/Update' },
    { name: 'operationRole.delete', address: 'operationRole/Delete' },
    { name: 'operationClaim.list', address: 'OperationClaim/List' },

    // AccessControl
    { name: 'accessControl.modify', address: 'AccessControl/Modify' },
    { name: 'accessControl.get-list', address: 'UserDataAccessControl/List' },

    // Print
    { name: 'print.variables-list', address: 'Print/PrintVariableList' },
    { name: 'print.variables-modify', address: 'Print/ModifyVariables' },
    { name: 'print.list', address: 'Print/List' },
    { name: 'print.get', address: 'Print/Get' },
    { name: 'print.delete', address: 'Print/Delete' },
    { name: 'print.create', address: 'Print/Create' },
    { name: 'print.update', address: 'Print/Update' },
    { name: 'print.setDefault', address: 'Print/SetDefault' },

    // Frequent Descriptions
    { name: 'frequentDescriptions.list', address: 'FrequentDescription/List' },
    { name: 'frequentDescriptions.modify', address: 'FrequentDescription/Modify' },

    // Attachments
    { name: 'attachments.list', address: 'Attachment/List' },
    { name: 'attachments.create', address: 'Attachment/Create' },
    { name: 'attachments.download', address: 'Download/DownloadAttachment' },
    { name: 'attachments.delete', address: 'Attachment/Delete' },
    { name: 'attachments.count', address: 'Attachment/Count' },

    // Change Log
    { name: 'changelog.list', address: 'ChangeLog/List' },


    // note
    { name: 'note.modify', address: 'Note/Modify' },
    { name: 'note.get', address: 'Note/Get' },
    { name: 'note.delete', address: 'Note/Delete' },

    // backup and restore
    { name: 'backupRestore.list', address: 'BackupAndRestore/List' },
    { name: 'backupRestore.backup', address: 'BackupAndRestore/Backup' },
    { name: 'backupRestore.restore', address: 'BackupAndRestore/Restore' },
    { name: 'backupRestore.getInfo', address: 'BackupAndRestore/GetInfo' },
    { name: 'backupRestore.restoreLogs', address: 'BackupAndRestore/RestoreLogs' },

    // notification
    { name: 'notification.create', address: 'Notification/Create' },
    { name: 'notification.seen', address: 'Notification/Seen' },
    { name: 'notification.delete', address: 'Notification/Delete' },
    { name: 'notification.Get', address: 'Notification/Get' },

    // Closing
    { name: 'closing.checkDocumentsIsSorted', address: 'Closing/CheckDocumentsIsSorted' },
    { name: 'closing.checkDocumentsIsAccepted', address: 'Closing/CheckDocumentsIsAccepted' },
    { name: 'closing.closeAccounts', address: 'Closing/CloseAccounts' },
    { name: 'closing.transferProfitDamageRemain', address: 'Closing/TransferProfitDamageRemain' },
    { name: 'closing.delete', address: 'Closing/Delete' },

    // codepattern
    { name: 'codepattern.list', address: 'CodePattern/List' },
    { name: 'codepattern.get', address: 'CodePattern/Get' },
    { name: 'codepattern.create', address: 'CodePattern/Create' },
    { name: 'codepattern.update', address: 'CodePattern/Update' },
    { name: 'codepattern.delete', address: 'CodePattern/Delete' },
    { name: 'codepattern.getSubjects', address: 'CodePattern/GetSubjects' },
  ])

  Endpoints.addModule('/api/v1.0/sale/', [
    // moadian
    { name: 'sale.moadian.getAllMemory', address: 'Moadian/GetAllMemory', commercialAccess: ['Sale'] },
    { name: 'sale.moadian.modifySettings', address: 'Moadian/ModifySettings', commercialAccess: ['Sale'] },
    { name: 'sale.moadian.getSettings', address: 'Moadian/GetSettings', commercialAccess: ['Sale'] },
    { name: 'sale.moadian.convert', address: 'Moadian/Convert', commercialAccess: ['Sale'] },
    { name: 'sale.moadian.getNumber', address: 'Moadian/GetNumber', commercialAccess: ['Sale'] },
    { name: 'sale.moadian.setNumbers', address: 'Moadian/SetNumbers', commercialAccess: ['Sale'] },
    { name: 'sale.moadian.list', address: 'Moadian/List', commercialAccess: ['Sale'] },
    { name: 'sale.moadian.send', address: 'Moadian/Send', commercialAccess: ['Sale'] },
    { name: 'sale.moadian.bulkSend', address: 'Moadian/BulkSend', commercialAccess: ['Sale'] },
    { name: 'sale.moadian.status', address: 'Moadian/Status', commercialAccess: ['Sale'] },
    { name: 'sale.moadian.changeSubject', address: 'Moadian/ChangeSubject', commercialAccess: ['Sale'] },
    { name: 'sale.moadian.changeType', address: 'Moadian/ChangeInvoiceType', commercialAccess: ['Sale'] },
    { name: 'sale.moadian.changeSettlementType', address: 'Moadian/ChangeSettlementType', commercialAccess: ['Sale'] },
    { name: 'sale.moadian.delete', address: 'Moadian/Delete', commercialAccess: ['Sale'] },

    // excel operation
    { name: 'sale.excel.getFields', address: 'ExcelOperation/GetFields', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.excel.import', address: 'ExcelOperation/Import', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.download.export', address: 'Download/Export', commercialAccess: ['Sale', 'Warehouse'] },

    // FactorAttachedPayment
    { name: 'sale.factor.attach.get-list-dynamic', address: 'FactorAttachedPayment/ListDynamic' },
    { name: 'sale.factor.attach.get-single-dynamic', address: 'FactorAttachedPayment/GetDynamic' },
    { name: 'sale.factor.attach.get-attachable-factors', address: 'FactorAttachedPayment/GetAttachableFactors' },
    { name: 'sale.factor.attach.get-attachable-transactions', address: 'FactorAttachedPayment/GetAttachableTransactions' },
    { name: 'sale.factor.attach.get-factor-attached-payments-byEntityId', address: 'FactorAttachedPayment/GetFactorAttachedPaymentListByEntityId' },
    { name: 'sale.factor.attach.modify', address: 'FactorAttachedPayment/ModifyFactorPaymentAttaches' },
    { name: 'sale.factor.attach-by-transaction.modify', address: 'FactorAttachedPayment/ModifyFactorsPaymentAttaches' },

    // FactorBunch
    { name: 'sale.factor.bunch.list', address: 'FactorBunch/List' },
    { name: 'sale.factor.bunch.get-list-dynamic', address: 'FactorBunch/ListDynamic' },
    { name: 'sale.factor.bunch.get-single-dynamic', address: 'FactorBunch/GetDynamic' },
    { name: 'sale.factor.bunch.modify', address: 'FactorBunch/Modify' },
    { name: 'sale.factor.bunch.get-last-code', address: 'FactorBunch/LastCode' },

    // Factor
    { name: 'sale.factor.get-list-dynamic', address: 'Factor/ListDynamic' },
    { name: 'sale.factor.get-single-dynamic', address: 'Factor/GetDynamic' },
    { name: 'sale.factor.get-list', address: 'Factor/List' },
    { name: 'sale.factor.paged-list', address: 'Factor/PagedList' },
    { name: 'sale.factor.get-full-data', address: 'Factor/FullData' },
    { name: 'sale.factor.get-single', address: 'Factor/Get' },
    { name: 'sale.factor.get-unit-prices', address: 'Factor/GetUnitPrices' },
    { name: 'sale.factor.change-factory-state', address: 'Factor/ChangeFactorState' },
    { name: 'sale.factor.cancellation-factor', address: 'Factor/CancelationFactor' },
    { name: 'sale.factor.get-floating-center-extra-data', address: 'Factor/GetFloatingCenterExtraData' },
    { name: 'sale.factor.change-state', address: 'Factor/ChangeState' },
    { name: 'sale.factor.create', address: 'Factor/Create' },
    { name: 'sale.factor.update', address: 'Factor/Update' },
    { name: 'sale.factor.delete', address: 'Factor/Delete' },
    { name: 'sale.factor.navigate', address: 'Factor/Navigate' },
    { name: 'sale.factor.get-receipt-hawala-information', address: 'Factor/GetReceiptHawalaInformation' },
    { name: 'sale.factor.trace', address: 'Factor/Trace' },
    { name: 'sale.factor.batch-change-factor-bunch', address: 'Factor/BatchChangeFactorBunch' },
    { name: 'sale.factor.batch-delete', address: 'Factor/BatchDelete' },
    { name: 'sale.factor.change-document-account', address: 'Factor/ChangeDocumentAccount' },
    { name: 'sale.factor.factor-hawala-list', address: 'Factor/SaleFactorHawalaList' },
    { name: 'sale.factor.bulk-insert-hawala', address: 'Factor/BulkInsertHawala' },
    { name: 'sale.factor.pre-process-factor-excel', address: 'Factor/PreProcessFactorExcel' },

    //serviceExpenseFactor
    { name: 'sale.cost-factor.create', address: 'CostFactor/Create' },
    { name: 'sale.cost-factor.update', address: 'CostFactor/Update' },
    { name: 'sale.cost-factor.delete', address: 'CostFactor/Delete' },
    { name: 'sale.cost-factor.get', address: 'CostFactor/Get' },
    { name: 'sale.cost-factor.list', address: 'CostFactor/List' },
    { name: 'sale.cost-factor.navigate', address: 'CostFactor/navigate' },
    { name: 'sale.cost-factor.valid-receipts-list', address: 'WarehouseReceiptHawala/GetValidReceiptsForCostFactor' },

    //CommissionAnnouncement
    { name: 'sale.commission.unsettled-factor-list', address: 'Factor/GetNotSettledFactorsOfMarketer' },
    { name: 'sale.commission.create', address: 'CommissionAnnouncement/create' },
    { name: 'sale.commission.update', address: 'CommissionAnnouncement/update' },
    { name: 'sale.commission.list', address: 'CommissionAnnouncement/list' },
    { name: 'sale.commission.delete', address: 'CommissionAnnouncement/delete' },
    { name: 'sale.commission.get', address: 'CommissionAnnouncement/get' },

    // ProductBarcode
    { name: 'sale.product.barcode.get-list', address: 'ProductBarcode/List', commercialAccess: ['Sale', 'Warehouse'] },

    // Product
    { name: 'sale.product.get-list-for-factor', address: 'Product/ListForFactor', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.get-integrated-list-for-factor', address: 'Product/IntegratedListForFactor', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.get-list', address: 'Product/List', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.get-list-dynamic', address: 'Product/ListDynamic', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.get-single-dynamic', address: 'Product/GetDynamic', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.list', address: 'Product/List', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.get', address: 'Product/Get', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.create', address: 'Product/Create', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.update', address: 'Product/Update', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.delete', address: 'Product/Delete', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.bulkDelete', address: 'Product/BulkDelete', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.navigate', address: 'Product/Navigate', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.get-product-stock', address: 'Product/GetProductStock', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.get-product-warehouse-stock', address: 'Product/GetProductStockOnWarehouse', commercialAccess: 'Warehouse' },
    { name: 'sale.product.get-last-price', address: 'Product/GetLastPrice', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.get-last-sale-and-buy-price', address: 'Product/GetLastSaleAndBuyPrice' },
    { name: 'sale.product.get-order-points', address: 'Product/GetOrderPoints', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.get-product-stock-price', address: 'Product/GetProductsStockPrice', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.get-multiple-product-stock-price', address: 'Product/GetMultipleProductStockPrice', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.paged-list', address: 'Product/PagedList', commercialAccess: ['Sale', 'Warehouse'] },


    // ProductFloating
    { name: 'sale.product.floating.get-list-dynamic', address: 'ProductFloating/ListDynamic', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.floating.list', address: 'ProductFloating/List', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.floating.get', address: 'ProductFloating/Get', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.floating.create', address: 'ProductFloating/Create', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.floating.update', address: 'ProductFloating/Update', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.floating.delete', address: 'ProductFloating/Delete', commercialAccess: ['Sale', 'Warehouse'] },

    // ProductFloatingValue
    { name: 'sale.product.floating.value.list', address: 'ProductFloatingValue/List', commercialAccess: ['Sale', 'Warehouse'] },

    // ProductGroup
    { name: 'sale.product.group.get-list', address: 'ProductGroup/List', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.group.get-single', address: 'ProductGroup/Get', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.group.create', address: 'ProductGroup/Create', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.group.update', address: 'ProductGroup/Update', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.group.delete', address: 'ProductGroup/Delete', commercialAccess: ['Sale', 'Warehouse'] },

    // ProductOperator
    { name: 'sale.product.operator.get-list', address: 'ProductOperator/List', commercialAccess: ['Sale', 'Warehouse'] },

    // ProductPrice
    { name: 'sale.product.price.get-list', address: 'ProductPrice/List', commercialAccess: ['Sale', 'Warehouse'] },

    // ProductPriceGroup
    { name: 'sale.product.price.group.get-list', address: 'ProductPriceGroup/List', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.price.group.get-single', address: 'ProductPriceGroup/Get', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.price.group.create', address: 'ProductPriceGroup/Create', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.price.group.update', address: 'ProductPriceGroup/Update', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.price.group.delete', address: 'ProductPriceGroup/Delete', commercialAccess: ['Sale', 'Warehouse'] },

    // ProductPriceLevel
    { name: 'sale.product.price.level.get-list-dynamic', address: 'ProductPriceLevel/ListDynamic', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.price.level.get-single-dynamic', address: 'ProductPriceLevel/GetDynamic', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.product.price.level.modify', address: 'ProductPriceLevel/Modify', commercialAccess: ['Sale', 'Warehouse'] },

    // ProductUnit
    { name: 'sale.product.unit.get-list', address: 'ProductUnit/List', commercialAccess: ['Sale', 'Warehouse'] },

    // Warehouse
    { name: 'sale.warehouse.list', address: 'Warehouse/List', commercialAccess: 'Warehouse' },
    { name: 'sale.warehouse.get', address: 'Warehouse/Get', commercialAccess: 'Warehouse' },
    { name: 'sale.warehouse.modify', address: 'Warehouse/Modify', commercialAccess: 'Warehouse' },
    { name: 'sale.warehouse.get-products-stock', address: 'Warehouse/GetProductsStock', commercialAccess: 'Warehouse' },
    { name: 'sale.warehouse.create', address: 'Warehouse/Create', commercialAccess: 'Warehouse' },
    { name: 'sale.warehouse.update', address: 'Warehouse/Update', commercialAccess: 'Warehouse' },
    { name: 'sale.warehouse.delete', address: 'Warehouse/Delete', commercialAccess: 'Warehouse' },

    // WarehouseTransfer
    { name: 'warehouseTransfer.list', address: 'WarehouseTransfer/List', commercialAccess: 'Warehouse' },
    { name: 'warehouseTransfer.get', address: 'WarehouseTransfer/Get', commercialAccess: 'Warehouse' },
    { name: 'warehouseTransfer.create', address: 'WarehouseTransfer/Create', commercialAccess: 'Warehouse' },
    { name: 'warehouseTransfer.update', address: 'WarehouseTransfer/Update', commercialAccess: 'Warehouse' },
    { name: 'warehouseTransfer.delete', address: 'WarehouseTransfer/Delete', commercialAccess: 'Warehouse' },
    { name: 'warehouseTransfer.confirm', address: 'WarehouseTransfer/Confirm', commercialAccess: 'Warehouse' },

    // WarehouseTaking
    { name: 'warehouseTaking.list', address: 'warehouseTaking/List', commercialAccess: 'Warehouse' },
    { name: 'warehouseTaking.get', address: 'warehouseTaking/Get', commercialAccess: 'Warehouse' },
    { name: 'warehouseTaking.create', address: 'warehouseTaking/Create', commercialAccess: 'Warehouse' },
    { name: 'warehouseTaking.update', address: 'warehouseTaking/Update', commercialAccess: 'Warehouse' },
    { name: 'warehouseTaking.delete', address: 'warehouseTaking/Delete', commercialAccess: 'Warehouse' },
    { name: 'warehouseTaking.navigate', address: 'warehouseTaking/Navigate', commercialAccess: 'Warehouse' },

    // WarehouseTakingPDA
    { name: 'pda.list', address: 'warehouseTakingPDA/List', commercialAccess: 'Warehouse' },
    { name: 'pda.get', address: 'warehouseTakingPDA/Get', commercialAccess: 'Warehouse' },
    { name: 'pda.create', address: 'warehouseTakingPDA/Create', commercialAccess: 'Warehouse' },
    { name: 'pda.update', address: 'warehouseTakingPDA/Update', commercialAccess: 'Warehouse' },
    { name: 'pda.delete', address: 'warehouseTakingPDA/Delete', commercialAccess: 'Warehouse' },

    // Settings
    { name: 'sale.settings.get', address: 'SaleSetting/GetSettings', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.settings.modify', address: 'SaleSetting/ModifySettings', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'sale.reports.get', address: 'report/get', commercialAccess: ['Sale', 'Warehouse'] },


    // Product Classifications
    { name: 'productClassification.list', address: 'ProductClassification/List', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'productClassification.create', address: 'ProductClassification/Create', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'productClassification.delete', address: 'ProductClassification/Delete', commercialAccess: ['Sale', 'Warehouse'] },
    { name: 'productClassification.update', address: 'ProductClassification/Update', commercialAccess: ['Sale', 'Warehouse'] },

    // Product Request
    { name: 'ProductRequest.list', address: 'ProductRequest/List' },
    { name: 'ProductRequest.create', address: 'ProductRequest/Create' },
    { name: 'ProductRequest.delete', address: 'ProductRequest/Delete' },
    { name: 'ProductRequest.update', address: 'ProductRequest/Update' },
    { name: 'ProductRequest.confirm', address: 'ProductRequest/Confirmation' },
    { name: 'ProductRequest.get', address: 'ProductRequest/Get' },

    // Product Convert Formula
    { name: 'ProductConvertFormula.create', address: 'ProductConvertFormula/Create' },
    { name: 'ProductConvertFormula.update', address: 'ProductConvertFormula/Update' },
    { name: 'ProductConvertFormula.delete', address: 'ProductConvertFormula/Delete' },
    { name: 'ProductConvertFormula.list', address: 'ProductConvertFormula/List' },
    { name: 'ProductConvertFormula.get', address: 'ProductConvertFormula/Get' },
    { name: 'ProductConvertFormula.navigate', address: 'ProductConvertFormula/Navigate' },

    // Product Convert
    { name: 'ProductConvert.create', address: 'ProductConvert/Create' },
    { name: 'ProductConvert.update', address: 'ProductConvert/Update' },
    { name: 'ProductConvert.delete', address: 'ProductConvert/Delete' },
    { name: 'ProductConvert.list', address: 'ProductConvert/List' },
    { name: 'ProductConvert.get', address: 'ProductConvert/Get' },
    { name: 'ProductConvert.navigate', address: 'ProductConvert/Navigate' },

    // Buy Order
    { name: 'buyOrder.list', address: 'BuyOrder/List' },
    { name: 'buyOrder.create', address: 'BuyOrder/Create' },
    { name: 'buyOrder.delete', address: 'BuyOrder/Delete' },
    { name: 'buyOrder.update', address: 'BuyOrder/Update' },
    { name: 'buyOrder.confirm', address: 'BuyOrder/Confirmation' },
    { name: 'buyOrder.get', address: 'BuyOrder/Get' },

    // Warehouse Receipt Hawala
    { name: 'receiptHawala.get', address: 'WarehouseReceiptHawala/Get', commercialAccess: 'Warehouse' },
    { name: 'receiptHawala.create', address: 'WarehouseReceiptHawala/Create', commercialAccess: 'Warehouse' },
    { name: 'receiptHawala.update', address: 'WarehouseReceiptHawala/Update', commercialAccess: 'Warehouse' },
    { name: 'receiptHawala.delete', address: 'WarehouseReceiptHawala/Delete', commercialAccess: 'Warehouse' },
    { name: 'receiptHawala.list', address: 'WarehouseReceiptHawala/list', commercialAccess: 'Warehouse' },
    { name: 'receiptHawala.navigate', address: 'WarehouseReceiptHawala/Navigate', commercialAccess: 'Warehouse' },
    { name: 'receiptHawala.fullData', address: 'WarehouseReceiptHawala/FullData', commercialAccess: 'Warehouse' },
    { name: 'receiptHawala.getFactorInformation', address: 'WarehouseReceiptHawala/GetFactorInformation', commercialAccess: 'Warehouse' },
    { name: 'receiptHawala.change-receipt-document-account', address: 'WarehouseReceiptHawala/ChangeReceiptDocumentAccount', commercialAccess: 'Warehouse' },
    { name: 'receiptHawala.product-stock-account-list', address: 'WarehouseReceiptHawala/ProductStockAccountList', commercialAccess: 'Warehouse' },
    { name: 'receiptHawala.warehouse-list', address: 'WarehouseReceiptHawala/WarhouseList', commercialAccess: 'Warehouse' },
    { name: 'receiptHawala.create-opening-receipt', address: 'WarehouseReceiptHawala/CreateOpeningReceipt', commercialAccess: 'Warehouse' },


    // Hawala Document Form
    { name: 'hawalaDocumentForm.get', address: 'HawalaDocumentForm/Get', commercialAccess: 'Warehouse' },
    { name: 'hawalaDocumentForm.create', address: 'HawalaDocumentForm/Create', commercialAccess: 'Warehouse' },
    { name: 'hawalaDocumentForm.delete', address: 'HawalaDocumentForm/Delete', commercialAccess: 'Warehouse' },
    { name: 'hawalaDocumentForm.list', address: 'HawalaDocumentForm/List', commercialAccess: 'Warehouse' },
    { name: 'hawalaDocumentForm.getStartDate', address: 'HawalaDocumentForm/GetStartDate', commercialAccess: 'Warehouse' },
    { name: 'hawalaDocumentForm.navigate', address: 'HawalaDocumentForm/Navigate', commercialAccess: 'Warehouse' },
    { name: 'hawalaDocumentForm.change-document-account', address: 'HawalaDocumentForm/ChangeDocumentAccount', commercialAccess: 'Warehouse' },

    // Closing
    { name: 'closing.checkAllHawalaHaveDocument', address: 'Closing/CheckAllHawalaHaveDocument' },
    { name: 'closing.checkAllSaleFactorHaveHawala', address: 'Closing/CheckAllSaleFactorHaveHawala' },

    // Product Price Announce
    { name: 'productPriceAnnounce.create', address: 'ProductPriceAnnounce/Create' },
    { name: 'productPriceAnnounce.delete', address: 'ProductPriceAnnounce/Delete' },
    { name: 'productPriceAnnounce.get', address: 'ProductPriceAnnounce/Get' },
    { name: 'productPriceAnnounce.list', address: 'ProductPriceAnnounce/List' },

    // Center
    { name: 'sale.center.changeDocumentCenter', address: 'Center/ChangeDocumentCenter' },

    //Barcode Generator
    { name: 'sale.barcodeGenerator.generateBarcodeByProduct', address: 'Product/GenerateBarcodeByProduct' },
    { name: 'sale.barcodeGenerator.generateBarcodeByProductFloating', address: 'Product/GenerateBarcodeByProductFloatingJson' },

  ])
  Endpoints.addModule('/api/v1.0/treasury/', [
    // cheque
    { name: 'cheque.list', address: 'Cheque/list' },
    { name: 'cheque.itemsList', address: 'Cheque/getAllChequeItems' },
    { name: 'cheque.get', address: 'cheque/get' },
    { name: 'cheque.modify', address: 'cheque/modify' },
    { name: 'cheque.delete', address: id => 'cheque/delete/' + id },
    { name: 'cheque.navigate', address: 'cheque/navigate' },
    { name: 'cheque.trace', address: 'chequeTrace/list' },
    { name: 'cheque.docOfChequeTrace', address: 'chequeTrace/getDocument' },
    { name: 'cheque.revert', address: 'chequeTrace/revert' },

    // ChequeLocation
    { name: 'chequeLocation.list', address: 'chequeLocation/list' },
    { name: 'chequeLocation.modify', address: 'chequeLocation/modify' },

    // ChequeTraceReason
    { name: 'chequeTraceReason.list', address: 'chequeTraceReason/list' },
    { name: 'chequeTraceReason.modify', address: 'chequeTraceReason/modify' },

    // transaction
    { name: 'transaction.list', address: 'transaction/list' },
    { name: 'transaction.get', address: 'transaction/getByCodeWithDefaultValueOnNullResult' },
    { name: 'transaction.generalGet', address: 'transaction/get' },
    { name: 'transaction.create', address: 'transaction/create' },
    { name: 'transaction.update', address: 'transaction/update' },
    { name: 'transaction.delete', address: id => 'transaction/delete/' + id },
    { name: 'transaction.hybrid.get', address: 'transactionHybrid/get' },
    { name: 'transaction.hybrid.list', address: 'transactionHybrid/list' },
    { name: 'transaction.hybrid.create', address: 'transactionHybrid/create' },
    { name: 'transaction.hybrid.update', address: 'transactionHybrid/update' },
    { name: 'transaction.hybrid.delete', address: id => 'transactionHybrid/delete/' + id },
    { name: 'transaction.hybrid.navigate', address: id => 'transactionHybrid/navigate/' + id },
    { name: 'transaction.chequeOperation', address: 'chequeOperation/changeChequeState' },
    { name: 'transaction.navigate', address: 'transaction/navigate' },
    { name: 'transaction.get-last-code', address: 'transaction/GetLastCode' },
    { name: 'transaction.change-document-account', address: 'transaction/ChangeDocumentAccount' },
    { name: 'transaction.pagedList', address: 'transaction/PagedList' },

    // transfer
    { name: 'transfer.list', address: 'transfer/list' },
    { name: 'transfer.get', address: 'transfer/get' },
    { name: 'transfer.create', address: 'transfer/create' },
    { name: 'transfer.update', address: 'transfer/update' },
    { name: 'transfer.delete', address: id => 'transfer/delete/' + id },
    { name: 'transfer.navigate', address: 'transfer/navigate' },
    { name: 'transfer.change-document-account', address: 'transfer/ChangeDocumentAccount' },

    // settings
    { name: 'treasury.settings-get', address: 'Setting/GetSettings' },
    { name: 'treasury.settings-modify', address: 'Setting/ModifySettings' },

    // excel operation
    { name: 'treasury.excel.getFields', address: 'ExcelOperation/GetFields' },
    { name: 'treasury.excel.import', address: 'ExcelOperation/Import' },
    { name: 'treasury.download.export', address: 'Download/Export' },

    // Center
    { name: 'treasury.center.changeDocumentCenter', address: 'Center/ChangeDocumentCenter' },

    // reports
    { name: 'treasury.reports.get', address: 'report/get' },

  ])
  Endpoints.addModule('/api/v1.0/salary/', [
    // Checkout
    { name: 'checkout.get', address: 'Checkout/getInfo' },
    { name: 'checkout.create', address: 'Checkout/Create' },
    { name: 'checkout.delete', address: 'Checkout/Delete' },
    { name: 'checkout.list', address: 'Checkout/List' },


    // Report
    { name: 'report.financeSummeryListReport', address: 'Report/FinanceSummaryListReport' },
    { name: 'report.getTotalIncomeReport', address: 'Report/GetTotalIncomeReport' },
    { name: 'report.getPersonnelTotalIncomeReport', address: 'Report/GetPersonnelTotalIncomeReport' },
    { name: 'salary.report.get', address: 'Report/Get' },

    // BankPaymentAnnounce
    { name: 'bankPaymentAnnounce.get', address: 'BankPaymentAnnounce/Get' },
    { name: 'bankPaymentAnnounce.list', address: 'BankPaymentAnnounce/List' },
    { name: 'bankPaymentAnnounce.detail', address: 'BankPaymentAnnounce/Detail' },
    { name: 'bankPaymentAnnounce.create', address: 'BankPaymentAnnounce/Create' },
    { name: 'bankPaymentAnnounce.delete', address: 'BankPaymentAnnounce/Delete' },

    // CooperateType
    { name: 'cooperateType.listDynamic', address: 'CooperateType/ListDynamic' },
    { name: 'cooperateType.modify', address: 'CooperateType/modify' },

    // SalaryItemVariable
    { name: 'salaryItemVariable.create', address: 'SalaryItemVariable/Create' },
    { name: 'salaryItemVariable.update', address: 'SalaryItemVariable/Update' },
    { name: 'salaryItemVariable.delete', address: 'SalaryItemVariable/Delete' },
    { name: 'salaryItemVariable.get', address: 'SalaryItemVariable/Get' },
    { name: 'salaryItemVariable.list', address: 'SalaryItemVariable/List' },

    // SalaryItem
    { name: 'salaryItem.create', address: 'SalaryItem/Create' },
    { name: 'salaryItem.get', address: 'SalaryItem/Get' },
    { name: 'salaryItem.list', address: 'SalaryItem/List' },
    { name: 'salaryItem.systemSalaryItemList', address: 'SalaryItem/SystemSalaryItemList' },
    { name: 'salaryItem.copySystemSalaryItems', address: 'SalaryItem/CopySystemSalaryItems' },
    { name: 'salaryItem.update', address: 'SalaryItem/Update' },
    { name: 'salaryItem.functionList', address: 'SalaryItem/FunctionList' },
    { name: 'salaryItem.delete', address: 'SalaryItem/Delete' },
    { name: 'salaryItem.navigate', address: 'SalaryItem/Navigate' },
    { name: 'salaryItem.resultFunctionList', address: 'SalaryItem/ResultFunctionList' },
    { name: 'salaryItem.getUsedContract', address: 'SalaryItem/GetUsedContract' },
    { name: 'salaryItem.getDependency', address: 'SalaryItem/GetDependency' },

    // SalaryPeriod
    { name: 'salaryPeriod.list', address: 'SalaryPeriod/List' },
    { name: 'salaryPeriod.create', address: 'SalaryPeriod/Create' },
    { name: 'salaryPeriod.edit', address: 'SalaryPeriod/Update' },
    { name: 'salaryPeriod.delete', address: 'SalaryPeriod/Delete' },
    { name: 'salaryPeriod.setPassword', address: 'SalaryPeriod/SetPassword' },
    { name: 'salaryPeriod.changePassword', address: 'SalaryPeriod/ChangePassword' },
    { name: 'salaryPeriod.get', address: 'SalaryPeriod/Get' },
    { name: 'salaryPeriod.lock', address: 'SalaryPeriod/Lock' },
    { name: 'salaryPeriod.copy', address: 'SalaryPeriod/Copy' },
    { name: 'salaryPeriod.matchedPeriods', address: 'SalaryPeriod/MatchedSalaryPeriods' },

    // Workshop
    { name: 'workshop.list', address: 'Workshop/GetAll' },
    { name: 'workshop.get', address: 'Workshop/get' },
    { name: 'workshop.navigate', address: 'Workshop/Navigate' },
    { name: 'workshop.create', address: 'Workshop/Create' },
    { name: 'workshop.update', address: 'Workshop/Update' },
    { name: 'workshop.delete', address: 'Workshop/Delete' },

    // TaxCalculationTable
    { name: 'taxCalculationTable.list', address: 'TaxCalculationTableHeader/List' },
    { name: 'taxCalculationTable.get', address: 'TaxCalculationTableHeader/GetDynamic' },
    { name: 'taxCalculationTable.modify', address: 'TaxCalculationTableHeader/Modify' },
    { name: 'taxCalculationTable.systemList', address: 'TaxCalculationTableHeader/SystemList' },

    // TaminBranch
    { name: 'taminBranch.listDynamic', address: 'TaminBranch/ListDynamic' },
    { name: 'taminBranch.modify', address: 'TaminBranch/Modify' },

    // Personnel
    { name: 'personnel.create', address: 'Personnel/create' },
    { name: 'personnel.update', address: 'Personnel/update' },
    { name: 'personnel.delete', address: 'Personnel/delete' },
    { name: 'personnel.get', address: 'Personnel/get' },
    { name: 'personnel.navigate', address: 'Personnel/navigate' },
    { name: 'personnel.list', address: 'Personnel/List' },
    { name: 'personnel.updateCode', address: 'Personnel/UpdateCode' },

    // Contract
    { name: 'contract.get', address: 'Contract/Get' },
    { name: 'contract.delete', address: 'Contract/delete' },
    { name: 'contract.bulkModifySalaryItems', address: 'Contract/BulkModifySalaryItems' },
    { name: 'contract.update', address: 'Contract/Update' },
    { name: 'contract.list', address: 'Contract/List' },
    { name: 'contract.getContractFields', address: 'Contract/GetContractFields' },
    { name: 'contract.resetContracts', address: 'Contract/ResetContracts' },
    { name: 'contract.fullData', address: 'Contract/FullData' },
    { name: 'contract.lock', address: 'Contract/Lock' },
    { name: 'contract.logs', address: 'Contract/Logs' },
    { name: 'contract.changeDocumentCenter', address: 'Contract/ChangeDocumentCenter' },

    // Loan
    { name: 'loan.modify', address: 'Loan/Modify' },
    { name: 'loan.listDynamic', address: 'Loan/ListDynamic' },
    { name: 'loan.list', address: 'Loan/List' },
    { name: 'loan.getDynamic', address: 'Loan/GetDynamic' },

    // PersonelLoan
    { name: 'personelLoan.list', address: 'PersonelLoan/List' },
    { name: 'personelLoan.get', address: 'PersonelLoan/Get' },
    { name: 'personelLoan.create', address: 'PersonelLoan/Create' },
    { name: 'personelLoan.update', address: 'PersonelLoan/Edit' },
    { name: 'personelLoan.delete', address: 'PersonelLoan/Delete' },
    { name: 'personelLoan.installments', address: 'PersonelLoan/Installments' },
    { name: 'personelLoan.updateLoanInstallment', address: 'PersonelLoan/UpdateLoanInstallment' },

    // PersonnelCategory
    { name: 'personnelCategory.modify', address: 'PersonnelCategory/modify' },
    { name: 'personnelCategory.list', address: 'PersonnelCategory/list' },

    // PersonnelLend
    { name: 'personnelLend.modify', address: 'Lend/Modify' },
    { name: 'personnelLend.list', address: 'Lend/List' },
    { name: 'personnelLend.listDynamic', address: 'Lend/ListDynamic' },

    // SalaryCalculator
    { name: 'salaryCalculator.calculate', address: 'SalaryCalculator/Calculate' },
    { name: 'salaryCalculator.check-error', address: 'SalaryCalculator/CheckError' },

    // Settings
    { name: 'salary.settings-get', address: 'Setting/GetSettings' },
    { name: 'salary.settings-modify', address: 'Setting/ModifySettings' },
    { name: 'payslip-settings.get', address: 'Setting/GetPaySlipSettings' },
    { name: 'payslip-settings.modify', address: 'Setting/ModifyPaySlipSettings' },

    // SavingBox
    { name: 'savingBox.listDynamic', address: 'SavingBox/ListDynamic' },
    { name: 'savingBox.list', address: 'SavingBox/List' },
    { name: 'savingBox.modify', address: 'SavingBox/Modify' },

    // Workshop Insurance
    { name: 'workshopInsurance.listDynamic', address: 'InsuranceType/ListDynamic' },
    { name: 'workshopInsurance.getDynamic', address: 'InsuranceType/GetDynamic' },
    { name: 'workshopInsurance.modify', address: 'InsuranceType/Modify' },

    // Job Code
    { name: 'jobCode.listDynamic', address: 'JobCode/ListDynamic' },
    { name: 'jobCode.getDynamic', address: 'JobCode/GetDynamic' },
    { name: 'jobCode.modify', address: 'JobCode/Modify' },

    // Workplace Status
    { name: 'workplaceStatus.listDynamic', address: 'WorkPlaceStatus/ListDynamic' },
    { name: 'workplaceStatus.getDynamic', address: 'WorkPlaceStatus/GetDynamic' },
    { name: 'workplaceStatus.modify', address: 'WorkPlaceStatus/Modify' },

    // JobGroup
    { name: 'jobGroup.listDynamic', address: 'JobGroup/ListDynamic' },
    { name: 'jobGroup.list', address: 'JobGroup/List' },
    { name: 'jobGroup.modify', address: 'JobGroup/Modify' },

    // JobField
    { name: 'jobField.listDynamic', address: 'JobField/ListDynamic' },
    { name: 'jobField.list', address: 'JobField/List' },
    { name: 'jobField.modify', address: 'JobField/Modify' },

    { name: 'salaryDashboard.getFilterableColumns', address: 'Dashboard/GetFilterableColumns' },

    // Contract Salary Item
    { name: 'contractSalaryItem.list', address: 'ContractSalaryItem/List' },
    { name: 'contractSalaryItem.setValue', address: 'ContractSalaryItem/SetValue' },

    // PersonnelSavingBox
    { name: 'personnelSavingBox.list', address: 'PersonnelSavingBox/List' },
    { name: 'personnelSavingBox.get', address: 'PersonnelSavingBox/Get' },
    { name: 'personnelSavingBox.create', address: 'PersonnelSavingBox/Create' },
    { name: 'personnelSavingBox.update', address: 'PersonnelSavingBox/Update' },
    { name: 'personnelSavingBox.delete', address: 'PersonnelSavingBox/Delete' },

    // SavingBoxTransaction
    { name: 'savingBoxTransaction.get', address: 'SavingBoxTransaction/Get' },
    { name: 'savingBoxTransaction.list', address: 'SavingBoxTransaction/List' },
    { name: 'savingBoxTransaction.create', address: 'SavingBoxTransaction/Create' },
    { name: 'savingBoxTransaction.delete', address: 'SavingBoxTransaction/Delete' },

    // excel operation
    { name: 'salary.excel.getFields', address: 'ExcelOperation/GetFields' },
    { name: 'salary.excel.import', address: 'ExcelOperation/Import' },

    // dbf operation
    { name: 'dbf.read', address: 'DBFOperation/Read' },
    { name: 'dbf.check', address: 'DBFOperation/Check' },

    // dbf history
    { name: 'dbfHistory.list', address: 'DBFHistory/List' },

    // download export
    { name: 'salary.export', address: 'Export/Export' },
    { name: 'salary.download.export', address: 'Download/Export' },
    { name: 'download.export', address: 'Download/Export' },

    // Position
    { name: 'position.listDynamic', address: 'Position/ListDynamic' },
    { name: 'position.getDynamic', address: 'Position/GetDynamic' },
    { name: 'position.modify', address: 'Position/Modify' },

    // File Export Design
    { name: 'fileExportDesign.get', address: 'FileExportDesign/Get' },
    { name: 'fileExportDesign.list', address: 'FileExportDesign/List' },
    { name: 'fileExportDesign.create', address: 'FileExportDesign/Create' },
    { name: 'fileExportDesign.update', address: 'FileExportDesign/Update' },
    { name: 'fileExportDesign.delete', address: 'FileExportDesign/Delete' },

    // severance
    { name: 'severanceTable.list', address: 'Severance/List' },
    { name: 'severanceTable.get', address: 'Severance/GetDynamic' },
    { name: 'severanceTable.modify', address: 'Severance/Modify' },
    { name: 'severanceTable.systemList', address: 'Severance/SystemList' },

    // AnnualTaxTable
    { name: 'annualTaxTable.modify', address: 'AnnualTaxTable/Modify' },
    { name: 'annualTaxTable.list', address: 'AnnualTaxTable/List' },

    // Payslip Panel
    { name: 'payslipPanel.send', address: 'PayslipPanel/Send' },
    { name: 'payslipPanel.resetPassword', address: 'PayslipPanel/ResetPassword' },

    // Document
    { name: 'salary.document.create', address: 'Document/Create' },
    { name: 'salary.document.delete', address: 'Document/Delete' },
    { name: 'salary.document.contractsInDocument', address: 'Document/ContractsInDocument' },
    { name: 'salary.document.changeDocumentAccount', address: 'Document/ChangeDocumentAccount' },


  ])
  Endpoints.addModule('/api/v1.0/assets/', [
    { name: 'assetGroup.list', address: 'AssetGroup/List' },
    { name: 'assetGroup.create', address: 'AssetGroup/Create' },
    { name: 'assetGroup.delete', address: 'AssetGroup/Delete' },
    { name: 'assetGroup.update', address: 'AssetGroup/Update' },


    { name: 'assetLocation.list', address: 'AssetLocation/List' },
    { name: 'assetLocation.create', address: 'AssetLocation/Create' },
    { name: 'assetLocation.delete', address: 'AssetLocation/Delete' },
    { name: 'assetLocation.update', address: 'AssetLocation/Update' },


    { name: 'assetAcquisition.list', address: 'AssetAcquisition/List' },
    { name: 'assetAcquisition.create', address: 'AssetAcquisition/Create' },
    { name: 'assetAcquisition.delete', address: 'AssetAcquisition/Delete' },
    { name: 'assetAcquisition.update', address: 'AssetAcquisition/Update' },
    { name: 'assetAcquisition.get', address: 'AssetAcquisition/Get' },
    { name: 'assetAcquisition.navigate', address: 'AssetAcquisition/Navigate' },
    { name: 'assetAcquisition.change-document-account', address: 'AssetAcquisition/ChangeDocumentAccount' },
    { name: 'assetAcquisition.change-document-center', address: 'AssetAcquisition/ChangeDocumentCenter' },

    // Settings
    { name: 'assets.settings.get', address: 'Setting/GetSettings' },
    { name: 'assets.settings.modify', address: 'Setting/ModifySettings' },

    // AssetsCalculation
    { name: 'assetsCalculation.calculate', address: 'AssetCalculation/Calculate' },
    { name: 'assetsCalculation.delete', address: 'AssetCalculation/Delete' },
    { name: 'assetsCalculation.get', address: 'AssetCalculation/Get' },
    { name: 'assetsCalculation.getComputableAssetList', address: 'AssetCalculation/GetComputableAssetList' },
    { name: 'assetsCalculation.navigate', address: 'AssetCalculation/Navigate' },
    { name: 'assetsCalculation.getAssetCalculationDetail', address: 'AssetCalculation/GetAssetCalculationDetail' },

  ])
}